import { jsx } from 'react/jsx-runtime';
import { useModelCompareTranslation } from '../../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import '../../../../../../contexts/MenuContext/index.mjs';
import { BadgeVariants } from '../../../../../Badge/Badge.types.mjs';
import { Badge } from '../../../CompareTable.styles.mjs';
import { useMenu } from '../../../../../../contexts/MenuContext/context.mjs';
"use strict";
const Badges = ({
  product
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const {
    storeId
  } = useMenu();
  if (product.isNew) {
    return /* @__PURE__ */jsx(Badge, {
      variant: "lightGreen",
      children: formatMessage("New")
    });
  }
  if (!product?.customBadges?.length) {
    return null;
  }
  product.customBadges?.map((badge, i) => {
    return /* @__PURE__ */jsx(Badge, {
      variant: badge.variant || BadgeVariants.lightGrey,
      children: badge.value.type === "translation" ? formatMessage(typeof badge.value.value === "string" ? badge.value.value : badge.value.value(storeId)) : badge.value.value
    }, i);
  });
  return null;
};
export { Badges };
//# sourceMappingURL=Badges.mjs.map
